module.exports = __webpack_public_path__ + "img/20220415_110248.d9b6fb26.jpg";